/**
 * DispositionView — inline post-call form. `onDone` clears the disposition on
 * every tab (leader-aware), so it can be completed or dismissed from anywhere.
 */

import type { CallRecord } from '../../../lib/telephony';
import { CallDispositionForm } from '../CallDispositionForm';

interface Props {
  call: CallRecord;
  onDone: () => void;
}

export function DispositionView({ call, onDone }: Props) {
  return (
    <div>
      <div className="bg-gray-900 text-white px-3 py-2 text-sm font-medium">
        Gesprek afgerond
      </div>
      <CallDispositionForm call={call} onDone={onDone} />
    </div>
  );
}
